import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { connect } from "react-redux";

import App from "./containers/App/App";
import asyncComponent from "./helpers/AsyncFunc";

const RestrictedRoute = ({
  component: Component,
  loggedIn,
  user,
  ...rest
}) => {
  if (loggedIn && !user.ForcePasswordReset) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  } else if (loggedIn && user.ForcePasswordReset) {
    return <Redirect to="/passwordreset" />;
  } else {
    return <Route {...rest} render={() => <Redirect to="/signin" />} />;
  }
};

const PublicRoutes = ({ history, loggedIn, user }) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route
          exact
          path={"/signin"}
          component={asyncComponent(() => import("./containers/Index/signin"))}
        />
        <Route
          exact
          path={"/passwordreset"}
          component={asyncComponent(() =>
            import("./containers/Index/passwordReset")
          )}
        />
        <Route
          exact
          path={"/forgotpassword"}
          component={asyncComponent(() =>
            import("./containers/Index/forgotPassword")
          )}
        />
        <RestrictedRoute
          path="/"
          component={App}
          loggedIn={loggedIn}
          user={user}
        />
      </Switch>
    </ConnectedRouter>
  );
};

export default connect((state) => ({
  loggedIn: state.Auth.idToken !== null,
  user: state.Auth.user,
}))(PublicRoutes);
